import { useState } from 'react';

import { WaitlistModal } from './WaitlistModal';

interface WaitlistTriggerProps {
  source: string;
  className?: string;
  children: React.ReactNode;
}

export function WaitlistTrigger({ source, className, children }: WaitlistTriggerProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button className={className} onClick={() => setIsOpen(true)}>
        {children}
      </button>
      <WaitlistModal isOpen={isOpen} source={source} onClose={() => setIsOpen(false)} />
    </>
  );
}
